var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaja(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 313.47 335.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fbdea2;\n      }\n\n      .st1 {\n        mask: url(#mask);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st8 {\n        fill: url(#radial-gradient12);\n      }\n\n      .st9 {\n        fill: url(#radial-gradient10);\n      }\n\n      .st10 {\n        fill: url(#radial-gradient11);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st15 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st16 {\n        fill: #f2b86d;\n      }\n\n      .st17 {\n        fill: url(#radial-gradient);\n      }\n\n      .st18 {\n        fill: #fff;\n        opacity: .67;\n      }\n\n      .st19 {\n        fill: #fcdb95;\n      }\n\n      .st19, .st20, .st21 {\n        mix-blend-mode: color-dodge;\n      }\n\n      .st22 {\n        isolation: isolate;\n      }\n\n      .st23 {\n        mask: url(#mask-2);\n      }\n\n      .st24 {\n        mask: url(#mask-3);\n      }\n\n      .st25 {\n        mask: url(#mask-4);\n      }\n\n      .st26 {\n        mask: url(#mask-5);\n      }\n\n      .st27 {\n        mask: url(#mask-7);\n      }\n\n      .st28 {\n        mask: url(#mask-6);\n      }\n\n      .st29 {\n        mask: url(#mask-1);\n      }\n\n      .st30 {\n        mask: url(#mask-8);\n      }\n\n      .st31 {\n        fill: #603e52;\n      }\n\n      .st32 {\n        fill: #fbd27c;\n      }\n\n      .st33 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st34 {\n        fill: url(#radial-gradient6);\n      }\n\n      .st35 {\n        fill: url(#radial-gradient9);\n      }\n\n      .st36 {\n        fill: url(#radial-gradient8);\n      }\n\n      .st37 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st38 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st39 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st40 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st41 {\n        fill: url(#radial-gradient7);\n      }\n\n      .st21 {\n        fill: #fce7bb;\n      }\n\n      .st42 {\n        fill: url(#linear-gradient);\n        opacity: .56;\n      }\n\n      .st42, .st43, .st44, .st45 {\n        mix-blend-mode: multiply;\n      }\n\n      .st43 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st44 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st45 {\n        fill: url(#linear-gradient9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 136.51,
    y1: 200.21,
    x2: 206.14,
    y2: 312.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2b86d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f2bb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f4c68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f7d7ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fcefde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 122.78,
    y1: 304.84,
    x2: 127.12,
    y2: 311.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fefcf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fdf5ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fae9d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f7d8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f3c282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2b86d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 131.2,
    y1: 229.76,
    x2: 134.34,
    y2: 234.51,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 126.83,
    y1: 102.91,
    x2: 161.11,
    y2: 59.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f8904a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f4b360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f6bf78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f8cb91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f9d09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f9cf8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#face77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fbce70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fbd077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbd27c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 134.05,
    y1: 83.48,
    x2: 169.85,
    y2: 83.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fddb98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fcd890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fbd27d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbd27c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 164.95,
    y1: 97.17,
    x2: 139.38,
    y2: 70.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd27c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fbca77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fbb769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fd9652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fe6a33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff622e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 107.15,
    cy: 755.75,
    fx: 107.15,
    fy: 755.75,
    r: 6.37,
    gradientTransform: "translate(30.1 -93.46) scale(1.09 .21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 139.82,
    y: 63.91,
    width: 13.86,
    height: 2.67,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 146.75,
    cy: 65.25,
    rx: 6.93,
    ry: 1.34
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 14.68,
    cy: -1482.83,
    fx: 14.68,
    fy: -1482.83,
    r: 6.36,
    gradientTransform: "translate(-153.61 48.55) rotate(90) scale(1.14 .2)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 145.52,
    y: 58.01,
    width: 2.58,
    height: 14.48,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 146.81,
    cy: 65.25,
    rx: 1.29,
    ry: 7.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 129.45,
    y1: 70.01,
    x2: 129.45,
    y2: 33.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 123.02,
    y: 33.05,
    width: 12.85,
    height: 36.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 123.02,
    y: 33.05,
    width: 12.85,
    height: 36.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 154.33,
    y1: 45.62,
    x2: 154.33,
    y2: 8.67,
    xlinkHref: "#linear-gradient6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 147.91,
    y: 8.67,
    width: 12.85,
    height: 36.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 147.91,
    y: 8.67,
    width: 12.85,
    height: 36.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 171.74,
    y1: 54.73,
    x2: 171.74,
    y2: 17.77,
    xlinkHref: "#linear-gradient6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 165.32,
    y: 17.77,
    width: 12.85,
    height: 36.96,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 165.32,
    y: 17.77,
    width: 12.85,
    height: 36.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 131.56,
    y1: 230.05,
    x2: 134.69,
    y2: 234.79,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 122.92,
    y1: 261.48,
    x2: 159.15,
    y2: 306.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffa578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ff8f61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff8050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ff7647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 207.71,
    y1: 204.31,
    x2: 232.06,
    y2: 262.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff855c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff7648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6c3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 62.38,
    y1: 246.95,
    x2: 90.76,
    y2: 263.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ffb88e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ffa276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ff7e4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 132.36,
    cy: 119.35,
    fx: 132.36,
    fy: 119.35,
    r: 154.44,
    gradientTransform: "translate(9.82) scale(.96 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffc096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffb085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ff8859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 85.71,
    y1: 212.72,
    x2: 41.8,
    y2: 212.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff7e4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ffa276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ffb88e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc197"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: 42.86,
    cy: 194.15,
    fx: 42.86,
    fy: 194.15,
    r: 41.37,
    gradientTransform: "translate(9.82) scale(.96 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ffd3b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ffcdb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffc4a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffb694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ffa47e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ff8e64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: 128.91,
    cy: 167.82,
    fx: 128.91,
    fy: 167.82,
    r: 38.25,
    gradientTransform: "translate(9.82) scale(.96 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdec8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ffd0b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ffbe93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff895a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient5",
    cx: 68.2,
    cy: 132.1,
    fx: 68.2,
    fy: 132.1,
    r: 57.73,
    gradientTransform: "translate(9.82 2.75) scale(.96 1.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffddc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ffdac3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ffd2b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ffc5a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffb291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ff9973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ff7c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ff7748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient6",
    cx: 87.19,
    cy: 147,
    fx: 87.19,
    fy: 147,
    r: 31.72,
    gradientTransform: "translate(9.82 2.75) scale(.96 1.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ff9067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient7",
    cx: 138.08,
    cy: 171.68,
    fx: 138.08,
    fy: 171.68,
    r: 54.77,
    gradientTransform: "translate(9.82) scale(.96 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ff7a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ff8c61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ffa884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffd0b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd5ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 141.2,
    y1: 121.93,
    x2: 151.24,
    y2: 143.81,
    gradientTransform: "translate(.08 1.58) rotate(-.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ff7444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d86647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#82494e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603e52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient8",
    cx: 79.51,
    cy: 238.48,
    fx: 79.51,
    fy: 238.48,
    r: 34.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff7e4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ffa276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ffb88e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc197"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient9",
    cx: 26.57,
    cy: 1343.02,
    fx: 26.57,
    fy: 1343.02,
    r: 5.58,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 52.95,
    y: 187.4,
    width: 12.16,
    height: 2.34,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M52.95,188.57c0-.65,2.72-1.17,6.08-1.17s6.08.52,6.08,1.17-2.72,1.17-6.08,1.17-6.08-.52-6.08-1.17Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient10",
    cx: 123.13,
    cy: -1049.82,
    fx: 123.13,
    fy: -1049.82,
    r: 5.58,
    gradientTransform: "translate(-153.61 48.55) rotate(90) scale(1.14 .2)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 57.95,
    y: 182.22,
    width: 2.26,
    height: 12.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 59.08,
    cy: 188.57,
    rx: 1.13,
    ry: 6.35
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient11",
    cx: 107.74,
    cy: 1226.58,
    fx: 107.74,
    fy: 1226.58,
    r: 8.62,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 138.01,
    y: 162.31,
    width: 18.77,
    height: 3.62,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 147.4,
    cy: 164.12,
    rx: 9.39,
    ry: 1.81
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient12",
    cx: 101.62,
    cy: -1486.09,
    fx: 101.62,
    fy: -1486.09,
    r: 8.62,
    gradientTransform: "translate(-153.61 48.55) rotate(90) scale(1.14 .2)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 145.72,
    y: 154.32,
    width: 3.49,
    height: 19.61,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 147.47,
    cy: 164.12,
    rx: 1.75,
    ry: 9.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M260.54,310.73c-13.45,7.82-28.69,12.15-43.92,14.21-16.18,2.19-32.76,1.86-48.83-1.11-16-2.96-30.89-8.79-44.5-18.04-9.09-6.17-18.1-12.46-27.15-18.69-7.6-5.23-15.2-10.47-22.8-15.7-.07-.05-.81-.65-.89-.61,0,0,45.01-25.6,45.01-25.6l31.95-18.17,63.14-35.92s36.52,31.27,54.05,47.77c17.53,16.5,27.73,52.24-6.06,71.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M121.94,305.4l4.43,3.05c-1.55-.99-3.03-2.01-4.43-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M149.35,222.1l-33.73,19.19c3.9-3.69,8.6-7.18,14.1-10.38,6.01-3.49,12.61-6.43,19.62-8.81Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.61,60.76l-3.91-2.34c-3.24-1.94-7.72-1.66-12.66,1.3-9.89,5.92-17.9,20.31-17.9,32.14,0,5.92,2,10.08,5.24,12.01l3.91,2.34c-.65-.39-1.26-.87-1.8-1.44-2.16-2.25-3.44-5.85-3.44-10.57,0-11.83,8.02-26.22,17.9-32.14,3.95-2.36,7.6-3.02,10.55-2.2.75.21,1.45.51,2.11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M164.61,60.76c-.65-.39-1.36-.69-2.11-.9-2.96-.82-6.61-.16-10.55,2.2-9.89,5.92-17.9,20.31-17.9,32.14,0,4.72,1.28,8.33,3.44,10.57.55.57,1.15,1.05,1.8,1.44,3.24,1.94,7.71,1.66,12.66-1.3,9.89-5.92,17.9-20.31,17.9-32.14,0-5.92-2-10.08-5.24-12.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M151.95,100.55c7.88-4.71,14.26-16.18,14.26-25.6s-6.38-13.25-14.26-8.53c-7.88,4.71-14.26,16.18-14.26,25.6s6.38,13.25,14.26,8.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 146.75,
    cy: 65.25,
    rx: 6.93,
    ry: 1.34
  })), /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 146.81,
    cy: 65.25,
    rx: 1.29,
    ry: 7.24
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "129.97 68.74 128.92 69.34 128.92 34.32 129.97 33.72 129.97 68.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "154.86 44.35 153.81 44.96 153.81 9.94 154.86 9.33 154.86 44.35"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "171.35 53.6 170.3 54.2 170.3 21.24 171.35 20.64 171.35 53.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M149.66,222.4l-33.65,19.15c3.89-3.68,8.58-7.16,14.08-10.36,6-3.49,12.59-6.42,19.58-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.7,270.91c11.55,0,23.09,0,34.64,0-1.48,10.96-3.94,21.72-5.08,32.75-8.07,4.34-16.42,4.33-24.48,0-1.14-11.02-3.6-21.78-5.08-32.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M205.4,240.34c9.63-4.6,19.26-9.19,28.88-13.79,3.03,10.18,5.16,20.58,8.5,30.67-5.05,7.01-12.01,10.33-20.42,9.75-5.23-9.19-11.47-17.63-16.97-26.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M76.19,238.13c10.01,4.54,20.03,9.09,30.04,13.63-5.29,8.93-11.38,17.29-16.4,26.4-8.59.59-15.83-2.7-21.23-9.64,3.05-10.01,4.85-20.31,7.59-30.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st38",
    cx: 150.03,
    cy: 199.67,
    rx: 94.33,
    ry: 82.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94.09,225.39c0,8.88-3.69,14.52-9.34,15.88h0s-1.34.24-1.34.24l-5.3.94c.94-.18,1.82-.49,2.64-.91,3.99-2.06,6.48-6.91,6.48-13.95,0-13.46-9.11-29.82-20.35-36.54-5.79-3.46-11.01-3.7-14.72-1.28-.72.47-1.37,1.03-1.97,1.7l3.54-4.28c3.89-4.97,10.71-5.73,18.47-1.09,12.09,7.24,21.89,24.83,21.89,39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M87.22,227.58c0,7.04-2.5,11.89-6.48,13.95-2.62-.24-5.51-1.23-8.54-3.04-12.09-7.24-21.89-24.83-21.89-39.3,0-3.74.66-6.91,1.84-9.43,3.71-2.42,8.93-2.19,14.72,1.28,11.24,6.73,20.35,23.09,20.35,36.54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st31",
    cx: 102.87,
    cy: 182.22,
    rx: 2.73,
    ry: 2.5,
    transform: "translate(-105.99 169.39) rotate(-57.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M81.55,169.45c1.04-1.08,2.66-1.15,3.63-.15.96,1,.9,2.68-.15,3.76-1.04,1.08-2.66,1.15-3.63.15-.96-1-.9-2.68.15-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M82.41,169.58c.21-.21.53-.23.72-.03.19.2.18.53-.03.74-.21.21-.53.23-.72.03s-.18-.53.03-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M102.25,180.43c.21-.21.53-.23.72-.03.19.2.18.53-.03.74-.21.21-.53.23-.72.03-.19-.2-.18-.53.03-.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "50.23 191.5 50.14 191.41 50.23 191.5 50.23 191.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M159.27,200.42l-15.77,4.25c-.02-.39-.05-.78-.08-1.18-.83-10.15-5.56-22.08-13.78-32.88-.28-.37-.56-.73-.85-1.09,0,0-1.47-1.8-1.47-1.81.01-.01.02-.02.03-.03.42-.4.85-.79,1.3-1.17,8.7-7.42,22.49-9.07,31-.29.85.88,1.61,1.87,2.22,2.95,2.27,4.03,2.74,9,2.42,13.58-.22,3.19-.86,6.35-1.78,9.4-.41,1.37-.88,2.72-1.4,4.05-.25.63-1.26,4.07-1.85,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M104.83,151.65c-3-1.66-5.98-2.95-8.89-3.84-8.16-2.49-15.68-1.83-21.01,2.6-1.09.9-2.05,1.93-2.88,3.07-.58.8-1.1,1.65-1.56,2.56-.32-1.44-.59-2.92-.77-4.45-1.94-15.62,4.27-29.31,13.87-30.58,9.6-1.27,18.96,10.36,20.9,25.97.2,1.57.31,3.13.34,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M95.94,147.81c-8.16-2.49-15.68-1.83-21.01,2.6-1.09.9-2.05,1.93-2.88,3.07-.03-.24-.07-.49-.1-.73-1.71-13.71,2.34-25.55,9.03-26.43,6.4-.85,12.92,8.64,14.95,21.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M143.42,203.49c-.83-10.15-5.56-22.08-13.78-32.88-.28-.37-.56-.73-.85-1.09,11.06-6.37,22.2-6.87,27.1-.44,6,7.87.41,23.19-12.48,34.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M134.1,147.36l2.16,3.1s-.06.03-.09.04c-.71-1-1.46-2.05-2.19-3.09-1.03-1.45-2.04-2.89-2.94-4.19.04-.02.09-.04.13-.06l2.92,4.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.12,135.49s-.04,0-.06.02c-6.23,1.57-12.53,3.59-18.83,6.07-6.27,2.47-12.24,5.27-17.88,8.36-.03.01-.06.03-.09.05-.8-.93-1.63-1.91-2.45-2.87-1.15-1.35-2.29-2.69-3.3-3.9.04-.02.08-.05.13-.07,5.24-2.8,10.77-5.37,16.55-7.64,6.81-2.68,13.63-4.82,20.35-6.45.04-.01.08-.02.12-.03.95,1.12,1.99,2.35,3,3.55.85,1.01,1.69,2.01,2.45,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M173.12,135.49s-.04,0-.06.02c-6.23,1.57-12.53,3.59-18.83,6.07-6.27,2.47-12.24,5.27-17.88,8.36-.03.01-.06.03-.09.05-.8-.93-1.63-1.91-2.45-2.87.04-.02.07-.04.11-.06,4.01-2.2,8.19-4.26,12.52-6.15,8.07-3.53,16.16-6.29,24.12-8.3.03,0,.06-.02.09-.02.85,1.01,1.69,2.01,2.45,2.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M86.14,236.13c-2.32,4.53-6.48,6.6-11.7,5.83-5.23-.77-10.91-4.28-15.98-9.89-5.08-5.61-8.95-12.64-10.9-19.81-1.95-7.17-1.75-13.6.57-18.13,2.32-4.53,6.48-6.6,11.7-5.83,5.23.77,10.91,4.28,15.98,9.89,5.08,5.61,8.95,12.64,10.9,19.81,1.95,7.17,1.75,13.6-.57,18.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M52.95,188.57c0-.65,2.72-1.17,6.08-1.17s6.08.52,6.08,1.17-2.72,1.17-6.08,1.17-6.08-.52-6.08-1.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 59.08,
    cy: 188.57,
    rx: 1.13,
    ry: 6.35
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 147.4,
    cy: 164.12,
    rx: 9.39,
    ry: 1.81
  })), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 147.47,
    cy: 164.12,
    rx: 1.75,
    ry: 9.8
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaja);
export default __webpack_public_path__ + "static/media/caja.012b6e4a53592d15cd8d9fd2c51c9d0a.svg";
export { ForwardRef as ReactComponent };